import { getBrandCountries, getCountryName, getDefaultCountry, getLanguageName, getMapCountrySite, } from '../../countries';
import { getGlobalEData, getLocale, handleGlobalEBanner } from '../globalE';
export default async () => {
    const changeCountry = document.querySelector('[data-change-country]');
    if (!changeCountry)
        return;
    const countries = getBrandCountries();
    const globalEData = getGlobalEData();
    const defaultCountry = getDefaultCountry();
    if (!globalEData || !defaultCountry)
        return;
    // Display default country code from GlobalE cookie
    const mapCountrySite = getMapCountrySite();
    const countrySite = mapCountrySite[globalEData.countryISO];
    const userCountry = countries.find((c) => c.label === globalEData.countryISO);
    const userCountryCode = userCountry && countrySite && window.location.pathname.startsWith(`/${countrySite}`)
        ? userCountry.label
        : defaultCountry.code;
    // Handle click on country name
    changeCountry.addEventListener('click', (e) => {
        e.stopPropagation();
        handleGlobalEBanner(true);
    });
    // Display translated country label
    const countryName = await getCountryName(userCountryCode);
    changeCountry.innerHTML = countryName;
    const changeLanguage = document.querySelector('[data-change-language]');
    if (!changeLanguage)
        return;
    // Handle click on language control
    changeLanguage.addEventListener('click', (e) => {
        e.stopPropagation();
        handleGlobalEBanner(true);
    });
    // Display translated language label
    // Mirror the same URL-consistency check used for the country: if the cookie country
    // doesn't match the current site path, the cookie locale is stale — fall back to the
    // actual page language from the html lang attribute instead.
    const userLocale = userCountry && countrySite && window.location.pathname.startsWith(`/${countrySite}`)
        ? getLocale()
        : document.documentElement.lang.split('-')[0] || getLocale();
    const languageName = await getLanguageName(userLocale);
    changeLanguage.innerHTML = languageName;
};
